import { gql } from 'graphql-request'

const GET_PUBLISHER_FEES = gql`
  query queryPublisherFees($id: ID!) {
    publisherFees(id: $id) {
      revenueShareMobile
      revenueBonusMobile
      revenueShareRiskBufferMobile
      revenueShareTransactionFeeMobile
      revenueFeesHistory {
        dateSet
        revenueShareMobile
        revenueBonusMobile
        revenueShareRiskBufferMobile
        revenueShareTransactionFeeMobile
      }
      revenueFloorTurboApplications {
        id
        name
        revenueFloorTurboPlacements {
          id
          name
        }
      }
    }
  }
`

export default GET_PUBLISHER_FEES
